import { useCallback } from 'react';
import PropTypes from 'prop-types';
import Alert from '@mui/material/Alert';
import { cx } from 'ramda-extension';
import { connect, useDispatch } from 'react-redux';

import Cross from '@gef-ui/components/atoms/SvgIcon/Icons/Cross';
import ExclamationCircle from '@gef-ui/components/atoms/SvgIcon/Icons/ExclamationCircle';

import dialog from 'features/common/dialog';

import Section from '../../atoms/Section';

export const Dialog = ({ children, title, flex, name, config, mui = false, severity = 'error' }) => {
	const dispatch = useDispatch();

	const handleClose = useCallback(() => {
		dispatch(dialog.actions.close(name));
	}, [dispatch, name]);

	if (!config) {
		return null;
	}

	// temporary change - app still has some non-mui parts
	if (mui) {
		return (
			<Alert sx={{ mb: 1 }} severity={severity} onClose={handleClose}>
				{children}
			</Alert>
		);
	} else {
		return (
			<Section>
				<div className={cx('PKCLpopover', { 'PKCLpopover--block': !flex, 'PKCLpopover--flex': flex })}>
					<ExclamationCircle className="Icon--exclamationCircle" />
					{title}
					{!flex ? children : <span className="PKCLpopover__children">{children}</span>}
					<Cross onClick={handleClose} className="Icon--cross" />
				</div>
			</Section>
		);
	}
};
Dialog.propTypes = {
	children: PropTypes.any,
	config: PropTypes.object, // Fully customized
	flex: PropTypes.bool,
	icon: PropTypes.string,
	mui: PropTypes.bool,
	name: PropTypes.string,
	severity: PropTypes.oneOf(['error', 'warning', 'info', 'success']),
	title: PropTypes.string,
};

export default connect(
	(state, ownProps) => ({
		config: dialog.selectors.getConfig(state, ownProps.name),
	}),
	null,
)(Dialog);
